import { MessageCircle, Send, Youtube, Facebook, Info } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
    return (
        <footer className="mt-16 bg-blue-950 text-blue-100" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 grid md:grid-cols-4 gap-8">
                <div>
                    <div className="font-display font-bold text-xl text-white tracking-tight">
                        Morning &amp; Day &amp; Night · All Result
                    </div>
                    <p className="text-sm text-blue-200/80 mt-3 leading-relaxed">
                        Sabse fast aur reliable Teer results — Shillong Morning, Juwai, Shillong Teer,
                        Khanapara, Lucky Night aur Night Teer. Har din official update.
                    </p>
                    <div className="mt-5 grid grid-cols-2 gap-2 max-w-sm">
                        <a
                            href="https://whatsapp.com/channel/0029Vb8MzS9F1YlWpvY4M81x"
                            target="_blank" rel="noreferrer"
                            data-testid="footer-whatsapp-btn"
                            className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-full bg-emerald-500 text-white text-xs sm:text-sm font-semibold hover:bg-emerald-600 transition-colors"
                        >
                            <MessageCircle className="h-4 w-4" /> WhatsApp
                        </a>
                        <a
                            href="https://t.me/MorningSundayTeer"
                            target="_blank" rel="noreferrer"
                            data-testid="footer-telegram-btn"
                            className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-full bg-sky-500 text-white text-xs sm:text-sm font-semibold hover:bg-sky-600 transition-colors"
                        >
                            <Send className="h-4 w-4" /> Telegram
                        </a>
                        <a
                            href="https://youtube.com/@morningteerliveresult?si=EVVZwViXcUBP7RGt"
                            target="_blank" rel="noreferrer"
                            data-testid="footer-youtube-btn"
                            className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-full bg-red-600 text-white text-xs sm:text-sm font-semibold hover:bg-red-700 transition-colors"
                        >
                            <Youtube className="h-4 w-4" /> YouTube
                        </a>
                        <a
                            href="https://www.facebook.com/share/14m6gT2nyQ5/"
                            target="_blank" rel="noreferrer"
                            data-testid="footer-facebook-btn"
                            className="inline-flex items-center justify-center gap-2 px-3 py-2 rounded-full bg-blue-600 text-white text-xs sm:text-sm font-semibold hover:bg-blue-700 transition-colors"
                        >
                            <Facebook className="h-4 w-4" /> Facebook
                        </a>
                    </div>
                </div>

                <div>
                    <div className="uppercase tracking-widest text-xs text-yellow-300 font-semibold">Quick Links</div>
                    <ul className="mt-3 space-y-2 text-sm">
                        <li><Link to="/" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-home">Today’s Result</Link></li>
                        <li><Link to="/common-number" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-common">Common Number</Link></li>
                        <li><Link to="/dream-number" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-dream">Dream Number</Link></li>
                        <li><Link to="/hit-guti" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-hit">Direct Hit Guti</Link></li>
                        <li><Link to="/previous-results" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-prev">Previous Results</Link></li>
                        <li><Link to="/admin/login" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-admin">Admin</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="uppercase tracking-widest text-xs text-yellow-300 font-semibold">Company &amp; Legal</div>
                    <ul className="mt-3 space-y-2 text-sm">
                        <li><Link to="/about-us" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-about">About Us</Link></li>
                        <li><Link to="/contact-us" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-contact">Contact Us</Link></li>
                        <li><Link to="/privacy-policy" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link></li>
                        <li><Link to="/terms-and-conditions" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-terms">Terms &amp; Conditions</Link></li>
                        <li><Link to="/disclaimer" className="hover:text-yellow-300 transition-colors" data-testid="footer-link-disclaimer">Disclaimer</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10 py-5 text-center text-xs text-blue-300/70">
                © {new Date().getFullYear()} Shillong Morning Teer Result Today. All rights reserved.
            </div>
        </footer>
    );
};
